import React from 'react';
import CampaignFilter from './CampaignFilter';
import { optimizationType, recommendationPlatform, recommendationSource, matchesRecommendation } from '../../utils/performanceV2';

export default function RecommendationFilters({ cards, countCards = cards, campaigns, value, onChange, showCampaignFilter = true }) {
  const counted = countCards.filter((c) => matchesRecommendation(c, { ...value, campaigns: [] }, campaigns));
  const select = (key, label, choices) => (
    <label>{label}
      <select aria-label={label} value={value[key]} onChange={(e) => onChange({ ...value, [key]: e.target.value })}>
        <option value="all">All</option>
        {[...new Set(choices)].sort().map((choice) => <option key={choice}>{choice}</option>)}
      </select>
    </label>
  );
  return (
    <div className="perf-v2-filters">
      {select('platform', 'Platform', cards.map((c) => recommendationPlatform(c, campaigns)))}
      {showCampaignFilter && <CampaignFilter multiple value={value.campaigns} onChange={(campaignIds) => onChange({ ...value, campaigns: campaignIds })}
        options={campaigns.map((c) => ({ key: c.key, label: c.label, count: counted.filter((r) => r.camp === c.key).length }))}
        allCount={counted.length} />}
      {select('type', 'Optimization type', cards.map(optimizationType))}
      {select('source', 'Recommendation source', cards.map(recommendationSource))}
      <button type="button" className="btn btn-gho btn-sm" onClick={() => onChange({ campaigns: [], platform: 'all', type: 'all', source: 'all' })}>Clear filters</button>
    </div>
  );
}
